import React from 'react';
import { Chip, CircularProgress } from '@material-ui/core';
export const mapSelectIndexStateIndicators = {
  idle: <></>,
  loading: <CircularProgress className="loader" size={15} />,
  saved: <Chip size="small" label="Saved" color="primary" variant="outlined" />
};
